export function basicAuthHeader() {
    return {};
}
